// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-label[data-v-4826dce2] {\n  font-size: 0.675rem;\n}", ""]);
// Exports
module.exports = exports;
